<template>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "LogOut",
    methods: {
      ...mapActions([
        "LOG_OUT",
      ]),
    },
    mounted() {
      this.LOG_OUT();
      this.$router.push({ name: "Home"})
    },
  };
</script>